import moment from "moment"

export const formatDateOnly = (date: string | Date) =>
  moment(date).format("DD/MM/YYYY")

export const formatDate = (date: string | Date) =>
  moment(date).format("DD/MM/YYYY à HH:mm")
